import type { SVGProps } from 'react';

const SvgFitActualSize = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 3H6C4.35 3 3 4.35 3 6v12c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3V6c0-1.65-1.35-3-3-3m1 15c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1z"
    />
    <path
      fill="currentcolor"
      d="M12 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2M8.38 7.08c-.37-.15-.8-.07-1.09.22l-1 1A.996.996 0 0 0 7 10v6c0 .55.45 1 1 1s1-.45 1-1V8c0-.4-.24-.77-.62-.92m8 0c-.37-.15-.8-.07-1.09.22l-1 1A.996.996 0 0 0 15 10v6c0 .55.45 1 1 1s1-.45 1-1V8c0-.4-.24-.77-.62-.92"
    />
  </svg>
);
export default SvgFitActualSize;
